export default __webpack_public_path__ + "static/media/3-dots.e29897b9.svg";